module.exports = {
        srcSet: __webpack_public_path__ + "static/media/profile-on-mobile-400.81928529.webp"+" 400w",
        images: [{path: __webpack_public_path__ + "static/media/profile-on-mobile-400.81928529.webp",width: 400,height: 400}],
        src: __webpack_public_path__ + "static/media/profile-on-mobile-400.81928529.webp",
        toString: function(){return __webpack_public_path__ + "static/media/profile-on-mobile-400.81928529.webp"},
        
        width: 400,
        height: 400
      }